export default "__VITE_ASSET__BZodkrym__"